import { AxiosResponse } from 'axios';
import { StorableBaseService, FormField, PaginatedResponse } from './_base';
import { Project } from './projects';


interface ProjectCategoryListParams {
    ids?: Array<string>;
    page?: number;
    pagesize?: number;
    query?: string;
}

interface ProjectCategory {
    id: string;
    name: string;
}

class ProjectCategoryService extends StorableBaseService<ProjectCategory> {

    getRequiredPermissions() {return ['project_categories:view']; }

    constructor() {
        super("/api/v2/projects/categories/");
        this.formFields = [
            new FormField("name", "Name", { autofocus: true }),
        ];

        this.cacheTimeout = 60;
    }

    newResourceTitle(resourceId?: string): Promise<string> { return Promise.resolve("Kategorie hinzufügen") }
    newResourceConfirmation(resourceId?: string): Promise<string> { return Promise.resolve("Kategorie hinzugefügt") }
    deleteResourceMethod(resourceId?: string): Promise<string> { return Promise.resolve("delete") }
    deleteResourceTitle(resourceId?: string): Promise<string> { return Promise.resolve("Löschen") }
    deleteResourceConfirmation(resourceId?: string): Promise<string> { return Promise.resolve("Kategorie gelöscht") }

    listParams(params: ProjectCategoryListParams): Promise<AxiosResponse<PaginatedResponse<ProjectCategory>>> {
        if (!this.hasPermissions()) return this.emptyResultsPromise();

        params = params || {};

        const pagesize = params.pagesize || 50;
        const page = params.page || 1;
        const query = params.query || '';

        let url =
            '?limit=' + String(pagesize) +
            '&offset=' + String((page - 1) * pagesize) +
            '&q=' + encodeURIComponent(String(query));

        // Add results to details cache
        return this._get(url).then((response: AxiosResponse<PaginatedResponse<Project>>) => {
            if (!response) return response;
            this._cacheDetails(response.data.results);
            return response;
        })
    }
}

const projectCategoryService = new ProjectCategoryService();

export { projectCategoryService, ProjectCategoryService };
export type { ProjectCategory };

export default projectCategoryService;
